import { addToast } from '@mobi/component-library/Feedback/Toast'
import { isBetLoopProblemResponse } from './api/typeGuards'
import { ProblemResponse } from './api/types'

export async function handleApiErrorNotification(err: Error | ProblemResponse) {
  if (!isBetLoopProblemResponse(err)) return

  if ((err.detail || err.title) && err.requestId) {
    addToast({
      id: err.requestId,
      title: err.detail || err.title,
      icon: 'error',
      theme: 'dark',
    })
  }
}
